'use strict';

const _ = require('underscore');
const SVGView = require('common/ui/view/svg/index');

const IconBadgeView = SVGView.extend({
    className: 'faicon',

    initialize: function (params) {
        IconBadgeView.__super__.initialize.call(this, params);
        this.params = params;
        this._offset = params.offset ? params.offset : {x: 0, y: 0};
        this._width = params.width;
        this._height = params.height;
        this._fontSize = params.fontSize ? params.fontSize : 24;
        this._color = params.color;
        this._class = params.class;
        this._bgclass = params.bgclass;
        this._badge = params.badge;
        this._badgeFontSize = params.badgeFontSize;

        this._bg = null;
        this._badgeView= null;

        this.listenBadgeChange();
    },

    getBadge: function() {
        return this._badge;
    },

    getBadgeContent: function() {
        if (!this.getBadge() || !this.getBadge().content) {
            return null;
        }

        return this.getBadge().content();
    },

    listenBadgeChange: function() {
        if (!this.getBadge() || !this.getBadge().listen) {
            return null;
        }

        return this.getBadge().listen(_.bind(this.onChangeBadge, this));
    },

    render: function () {
        const width = this._width;
        const height = this._height;

        const x = this._offset.x - width / 2;
        const y = this._offset.y - height / 2;

        const bg = this.$el.append('foreignObject')
            .attr('width', width)
            .attr('height', height)
            .attr('transform', function () {
                return `translate(${x},${y})`;
            })
            .append('xhtml:div')
            .style('height', height)
            .style('text-align', 'center')
            .style('vertical-align', 'middle')
            .style('line-height', height + 'px')
            .style('font-size', this._fontSize + 'px')
            .style('dispaly', 'none')
            .style('color', this._color);
        this._bg = bg;

        if (this._bgclass) {
            bg.classed(this._bgclass, true);
        }

        const span = bg.append('xhtml:span');
        if (this._class) {
            span.attr('class', this._class);
        }

        const badge = bg.append('xhtml:span');
        this._badgeView = badge;
        badge.attr('class', 'badge')
            .style('font-size', this._badgeFontSize + 'px')
            .style('min-width', ((width - this._fontSize) * 0.9) + 'px');
        this.updateBadge();

        return this;
    },

    updateBadge: function() {
        if (this._bg == null || this._badgeView == null) {
            return;
        }

        const badge = this.getBadgeContent();
        if (! badge) {
            this._bg.style('display', 'none');
            return;
        }

        const badgeText = badge >= 100 ? '99+' : badge;

        this._bg.style('display', 'block');
        this._badgeView.html(badgeText);
    },

    onChangeBadge: function () {
        this.updateBadge();
    },
});

module.exports = IconBadgeView;



// WEBPACK FOOTER //
// ./common/ui/view/svg/icon-badge.js